/* Tactical X V18 — connect custom home product forms with native Dawn cart drawer.
   PDP <product-form> keeps Shopify's own implementation. */
(() => {
  'use strict';
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form.gx9-quickbuy');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.tx18Busy === 'true') return;
    const submit = form.querySelector('[type="submit"]');
    const drawer = document.querySelector('cart-drawer');
    if (!submit || !drawer || typeof drawer.getSectionsToRender !== 'function') {
      // Storefront has no drawer instance; use Shopify's regular cart route without losing the item.
      form.submit();
      return;
    }
    const originalText = submit.innerHTML;
    let error = form.querySelector('.tx18-cart-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'tx18-cart-error';
      error.setAttribute('role', 'alert');
      error.hidden = true;
      form.appendChild(error);
    }
    error.hidden = true;
    form.dataset.tx18Busy = 'true';
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    try {
      const payload = new FormData(form);
      payload.set('sections', drawer.getSectionsToRender().map(part => part.id).join(','));
      payload.set('sections_url', window.location.pathname);
      drawer.setActiveElement(submit);
      const url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const response = await fetch(url, {method: 'POST', headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: payload});
      const data = await response.json();
      if (!response.ok || data.status || !data.sections) throw new Error(data.description || data.message || 'Could not update cart. Please try again.');
      drawer.renderContents(data);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        try { publish(PUB_SUB_EVENTS.cartUpdate, {source: 'tx18-homepage', productVariantId: payload.get('id'), cartData: data}); } catch (_) {}
      }
    } catch (err) {
      error.textContent = err.message || 'Unable to add product. Please try again.';
      error.hidden = false;
    } finally {
      delete form.dataset.tx18Busy;
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
      submit.innerHTML = originalText;
    }
  }, true);
})();
